<template>
    <div id="FormTitle">
        <div :class="`title-size-${localTitleSize} title-align-${localTitleAlign} form-title`">
            <input type="text" placeholder="Başlık" v-model="localTitleText" @input="debouncedUpdateField" />
            <input type="text" placeholder="Bir alt başlık yazın" v-model="localSubTitle" @input="debouncedUpdateField" />
        </div>
    </div>
</template>

<script>
import { mapActions } from "vuex";
import { debounce } from "lodash";

export default {
    name: "FormTitle",
    props: {
        item: Object,
        titleSize: String,
        titleAlign: String,
        titleText: String,
        subTitle: String,
    },
    data() {
        return {
            localTitleText: this.titleText || "",
            localSubTitle: this.subTitle || "",
            localTitleSize: this.titleSize || "",
            localTitleAlign: this.titleAlign || "",
        };
    },
    created() {
        this.debouncedUpdateField = debounce(this.updateField, 500);
    },
    methods: {
        ...mapActions("forms", ["updateFormField"]),
        updateField() {
            const updateFields = {
                title: {
                    titleText: this.localTitleText,
                    subTitle: this.localSubTitle,
                    titleSize: this.localTitleSize,
                    titleAlign: this.localTitleAlign,
                },
            };
            this.updateFormField({
                siteId: this.item.siteId,
                formFieldId: this.item._id,
                updateFields: updateFields,
            });
            this.$emit("update-field", updateFields);
        },
    },
    watch: {
        titleText(newVal) {
            this.localTitleText = newVal;
        },
        subTitle(newVal) {
            this.localSubTitle = newVal;
        },
        titleSize(newVal) {
            this.localTitleSize = newVal;
        },
        titleAlign(newVal) {
            this.localTitleAlign = newVal;
        },
    },
};
</script>
<style lang="scss" scoped>
#FormTitle {
    .form-title {
        cursor: all-scroll;

        input[type="text"] {
            margin: 5px 0;
            font-size: 1.5rem;
            font-weight: normal;
            color: #2c3e50;
            font-family: Avenir, Helvetica, Arial, sans-serif;
            border: none;
            width: 100%;
            padding: 5px 0;
            box-sizing: border-box;
            background: transparent;
            outline: none;
            transition: border-color 0.3s;
        }

        input[type="text"]:nth-child(2) {
            font-size: 1.2rem;
            color: #666;
            font-weight: normal;
            font-family: Avenir, Helvetica, Arial, sans-serif;
            margin-top: 5px;
        }

        input[type="text"]:focus {
            border-bottom: 1px solid #1a73e8;  /* Odaklandığında alt çizgi rengi */
        }

        input[type="text"]::placeholder {
            color: #a9a9a9;
        }
    }

    .title-size-default {
        input[type="text"] {
            font-size: 1.5rem !important;  /* Varsayılan başlık boyutu */
        }
    }

    .title-size-wide {
        input[type="text"] {
            font-size: 1.7rem !important;  /* Geniş başlık boyutu */
        }
    }

    .title-size-small {
        input[type="text"] {
            font-size: 1.2rem !important;  /* Küçük başlık boyutu */
        }
    }

    .title-align-left {
        input[type="text"] {
            text-align: left;
        }

        input[type="text"]:nth-child(2) {
            text-align: left;
        }
    }

    .title-align-center {
        input[type="text"] {
            text-align: center;
        }

        input[type="text"]:nth-child(2) {
            text-align: center;
        }
    }

    .title-align-right {
        input[type="text"] {
            text-align: right;
        }

        input[type="text"]:nth-child(2) {
            text-align: right;
        }
    }
}
</style>
